import React, { ChangeEvent, FC, useEffect, useRef, useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { EventSelectInput, SelectInputType } from '../helpers/events';

interface Props {
  uuid: string;
  label?: string;
  text: string;
  namePoint: string;
  width?: string;
  changeHeightObject(heightPoint: number, uuid: string): void;
  disable?: boolean;
}
export const InputHeightPoint: FC<Props> = ({
  text,
  label,
  namePoint,
  changeHeightObject,
  uuid,
  width = '46%',
  disable,
}) => {
  const [currentText, setCurrentText] = useState(text ?? '');
  const [disableValue, setDisableValue] = useState('');
  const inputRef = useRef<HTMLInputElement>();

  const handlerChangeHeight = () => {
    changeHeightObject(+currentText, uuid);
    setDisableValue(currentText);
    if (inputRef.current) {
      inputRef.current?.blur();
    }
  };
  const handlerListenerSelectText = (evt: CustomEvent<SelectInputType>) => {
    if (namePoint === evt.detail.nameSide) {
      if (inputRef.current) {
        inputRef.current?.focus();
        inputRef.current?.select();
      }
    }
  };
  const changeText = (evt: ChangeEvent<HTMLInputElement>) => {
    const text = evt.target.value.replace(/[^0-9]/g, '');
    setCurrentText(text);
  };

  useEffect(() => {
    setCurrentText(text);
    setDisableValue(text);
  }, [text]);
  useEffect(() => {
    document.addEventListener(EventSelectInput, handlerListenerSelectText);
    return () => {
      document.addEventListener(EventSelectInput, handlerListenerSelectText);
    };
  }, []);

  return (
    <Box width={width} mt={1}>
      <Typography fontSize="14px" color={disable ? '#686868' : '#fff'}>{`${label}, mm`}</Typography>
      <Box width="100%" color="#fff" display="flex" alignItems="center">
        <TextField
          disabled={disable}
          autoComplete="off"
          inputRef={inputRef}
          hiddenLabel
          id="filled-hidden-label-small"
          value={disable ? '0' : currentText}
          onChange={changeText}
          variant="outlined"
          size="small"
          sx={{
            '& input': {
              width: width || '100px',
              color: '#000',
              borderColor: '#ffffff',
              borderRadius: '4px',
              backgroundColor: disable ? '#686868' : '#fff',
              fontSize: '12px',
              padding: '5px',
              textAlign: 'center',
            },
          }}
        />
        {disableValue !== currentText ? (
          <Button
            onClick={handlerChangeHeight}
            variant="contained"
            sx={{ minWidth: '40px', height: '27px', fontSize: '12px' }}
          >
            OK
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};
